module.exports = __webpack_public_path__ + "static/media/lenovo.84ac18d5.png";